import { MainMenuOption } from 'src/service/MainMenu';
import { AbstractUserRole } from 'src/service/UserPermission/AbstractUserRole';
import { ICCReview, Event } from 'src/api';

export class ICCRole extends AbstractUserRole {
  canView(option: MainMenuOption): boolean {
    const allowed = [MainMenuOption.iccreview];
    return allowed.includes(option);
  }

   
  canDownloadEventPdf(event: Event): boolean {
    return true;
  }

   
  canEditICCReview(review: ICCReview): boolean {
    return true;
  }
}
